if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        const newDrawer = sectionInnerHTML.querySelector('pickup-availability-drawer');
        document.body.appendChild(newDrawer);

        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          newDrawer.querySelector('.drawer__inner')?.classList.add(colorClass);
        });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.hide());
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);

        this.overlay = this.querySelector('.sap-pickup-drawer__overlay');
        this.overlay?.addEventListener('click', this.hide.bind(this));
        this.querySelector('.drawer__close')?.addEventListener('click', this.hide.bind(this));
      }

      hide() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        if (this.focusElement) removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        setTimeout(() => {
          this.classList.add('animate', 'active');
        });

        this.addEventListener(
          'transitionend',
          () => {
            const containerToTrapFocusOn = this.querySelector('.drawer__inner');
            const focusTarget = this.querySelector('.drawer__close');
            trapFocus(containerToTrapFocusOn, focusTarget);
          },
          { once: true }
        );

        document.body.classList.add('overflow-hidden');
      }
    }
  );

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('#ShowPickupAvailabilityDrawer, .sap-pickup__open');
    if (!openButton) return;

    const drawer = document.querySelector('pickup-availability-drawer');
    if (!drawer) return;

    event.preventDefault();
    drawer.show(openButton);
  });
}
